// The session token lives under `token` only; the persisted user object never repeats it,
// and never carries anything password-shaped.
const SECRET_FIELDS = ['password', 'new_password', 'token']

export const stripSecrets = (user, fields = SECRET_FIELDS) => {
    if (!user || typeof user !== 'object') return user
    const clean = { ...user }
    fields.forEach((field) => delete clean[field])
    return clean
}

// In-memory user: keeps the token (the socket and uploads still need it) but drops password fields.
export const toSessionUser = (user) => stripSecrets(user, ['password', 'new_password'])

export const persistUser = (user) => {
    localStorage.setItem('user', JSON.stringify(stripSecrets(user)))
}
